import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { showErrorMessage } from '~/domain/utils';
import { PermanentJobsService } from '../services';
import { IGetOnsiteInterviewListPayload } from '../types';

export const useGetOnsiteInterviewList = (payload: IGetOnsiteInterviewListPayload) => {
  const limit = payload.limit || 10;
  const page = payload.page || 1;

  const { data, error, isFetching, isLoading, isError } = useQuery({
    initialData: {
      data: [],
      pagination: { page: 1, pageSize: 10, total: 0, totalPages: 1 },
    },
    queryKey: [
      'GET_ONSITE_INTERVIEW_LIST',
      payload.jobPostingId,
      limit,
      payload.orderBy,
      payload.orderDirection,
      page,
      payload.status,
    ],
    queryFn: async () =>
      PermanentJobsService.getOnsiteInterviewList({
        ...payload,
        limit,
        page,
      }),
    retry: false,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [isError, error]);

  return {
    ...data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
